export default __webpack_public_path__ + "static/media/88t.c78a2337.jpg";